<template>
  <div>
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />
    <div
      id="interviewMailModal"
      class="modal fade"
      data-focus="false"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-scrollable">
        <ValidationObserver
          ref="letter"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <div class="letter-modal">
            <div class="note-wrap">
              <div class="letter-title">面談邀約</div>

              <template v-if="sendMail">
                <div class="note-title">可動態套入信件內容，請參考以下參數</div>
                <div class="note-table">
                  <table v-if="mailParameters">
                    <tr
                      v-for="(parameter, index) in mailParameters"
                      :key="index"
                    >
                      <th>{{ parameter.MailParameterName }}</th>
                      <td>
                        <span> {{</span>{{ parameter.MailParameterCode
                        }}<span>}} </span>
                      </td>
                    </tr>
                  </table>
                </div>
              </template>
            </div>

            <form @reset.prevent="reset">
              <div class="modal-content border-0">
                <perfect-scrollbar class="modal-body">
                  <div class="form-group">
                    <label for="">姓名：</label>
                    <span>{{ mail.Interviewee }}</span>
                  </div>

                  <div class="form-group">
                    <label for="">應徵職務：</label>
                    <span>{{ mail.Position }}</span>
                  </div>
                  <div class="form-group">
                    <label for=""> 單位面試主管： </label>
                    <el-select
                      class="w-100"
                      filterable
                      clearable
                      placeholder="請選擇"
                      v-model="mail.InterviewSupervisor"
                    >
                      <el-option
                        v-for="supervisor in supervisorOptions"
                        :key="supervisor.Guid"
                        :label="supervisor.Name"
                        :value="supervisor.Guid"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div class="form-group">
                    <label for="">
                      <span style="color: red">*</span>HR 面試人員：
                    </label>
                    <ValidationProvider
                      rules="required"
                      name="HR面試人員"
                      class="w-100"
                      v-slot="{ errors }"
                    >
                      <el-select
                        class="w-100"
                        filterable
                        placeholder="請選擇"
                        v-model="mail.InterviewHR"
                      >
                        <el-option
                          v-for="supervisor in supervisorOptions"
                          :key="supervisor.Guid"
                          :label="supervisor.Name"
                          :value="supervisor.Guid"
                        >
                        </el-option>
                      </el-select>
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      name="面談日期"
                      class="w-100"
                      v-slot="{ errors }"
                    >
                      <label for="">
                        <span style="color: red">*</span>面談日期：
                      </label>
                      <date-picker
                        id="reportDate"
                        class="w-100"
                        format="YYYY-MM-DD"
                        valueType="format"
                        placeholder="YYYY-MM-DD"
                        :disabled-date="$common.disabledDateBeforeToday"
                        v-model="mail.InterviewDate"
                      />
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      name="面談時間"
                      v-slot="{ errors }"
                    >
                      <label for="reportTime">
                        <span style="color: red">*</span>面談時間：
                      </label>
                      <date-picker
                        id="reportTime"
                        class="w-100"
                        format="HH:mm"
                        value-type="format"
                        type="time"
                        :default-value="new Date().setHours(8, 0, 0, 0)"
                        :minute-step="5"
                        placeholder="HH:mm"
                        v-model="mail.InterviewTime"
                      />
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      name="面談地點"
                      v-slot="{ errors }"
                    >
                      <label for="">
                        <span style="color: red">*</span>面談地點：
                      </label>
                      <el-select
                        class="w-100"
                        filterable
                        placeholder="請選擇"
                        v-model="mail.InterviewPlace"
                      >
                        <el-option
                          v-for="place in interviewPlaceOptions"
                          :key="place.Guid"
                          :label="place.Name"
                          :value="place.Name"
                        >
                        </el-option>
                      </el-select>
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>

                  <div class="form-group">
                    <label for=""><span class="mark">*</span>是否發送信件：</label>
                    <el-select
                      class="w-100"
                      :clearable="false"
                      v-model="sendMail"
                    >
                      <el-option label="是" :value="true" />
                      <el-option label="否" :value="false" />
                    </el-select>
                  </div>

                  <template v-if="sendMail">
                    <div class="form-group">
                      <label for="">面談說明：</label>
                      <textarea
                        class="form-control w-100"
                        rows="3"
                        maxlength="10000"
                        v-model="mail.Remark"
                      />
                    </div>

                    <div class="form-group">
                      <label for="">附件：</label>
                      <el-upload
                        class="upload-demo"
                        action
                        :auto-upload="false"
                        :show-file-list="false"
                        :on-change="uploadFile"
                      >
                        <el-button size="small" type="primary">
                          點擊上傳
                        </el-button>
                      </el-upload>
                      <template v-if="uploadFileList">
                        <div
                          v-for="file in uploadFileList"
                          :key="file.FileGuid"
                        >
                          <p
                            style="margin-top: 20px; cursor: pointer"
                            @click="
                              $common.downloadFile({
                                fileGuid: file.FileGuid,
                                fileType: file.FileContentType,
                              })
                            "
                          >
                            <eva-icon fill="#000" name="attach-outline" />
                            <span
                              style="
                                margin-left: 15px;
                                vertical-align: text-top;
                              "
                            >
                              {{ file.FileName }}
                            </span>
                            <span
                              style="
                                display: inline-block;
                                position: absolute;
                                right: 25px;
                              "
                              @click.stop="
                                removeFile({
                                  fileGuid: file.FileGuid,
                                  fileGroupGuid: file.FileGroupGuid,
                                })
                              "
                            >
                              <eva-icon fill="#000" name="trash-2-outline" />
                            </span>
                          </p>
                        </div>
                      </template>
                    </div>

                    <div class="form-group">
                      <label for=""> 信件範本： </label>
                      <el-select
                        class="w-100"
                        filterable
                        clearable
                        placeholder="請選擇"
                        @change="getMailTemplateDetail"
                        v-model="selectedTemplateGuid"
                      >
                        <el-option
                          v-for="template in mailTemplates"
                          :key="template.MailTemplateGuid"
                          :label="template.MailTemplateName"
                          :value="template.MailTemplateGuid"
                        >
                        </el-option>
                      </el-select>
                    </div>

                    <div class="form-group">
                      <ValidationProvider
                        rules="required"
                        name="信件主旨"
                        class="w-100"
                        v-slot="{ errors }"
                      >
                        <label for=""> <span class="mark">*</span>信件主旨： </label>
                        <input
                          placeholder="請輸入信件主旨或選擇範本"
                          class="form-control w-100"
                          v-model="mail.MailSubject"
                        />
                        <p class="text-danger" style="font-size: 13px">
                          {{ errors[0] }}
                        </p>
                      </ValidationProvider>
                    </div>

                    <div class="form-group">
                      <ValidationProvider
                        rules="required"
                        name="信件內容"
                        class="w-100"
                        v-slot="{ errors }"
                      >
                        <label for=""> <span class="mark">*</span>信件內容： </label>
                        <VueEditor
                          style="background: rgb(255, 255, 255)"
                          v-model="mail.MailTemplateBody"
                        />
                        <p class="text-danger" style="font-size: 13px">
                          {{ errors[0] }}
                        </p>
                      </ValidationProvider>
                    </div>
                  </template>
                </perfect-scrollbar>

                <div class="modal-footer">
                  <button
                    type="reset"
                    class="btn btn-secondary"
                    @click="closeInterviewModal"
                  >
                    取消
                  </button>
                  <button
                    v-if="sendMail"
                    type="button"
                    class="btn btn-primary"
                    @click="handleSubmit(preview)"
                  >
                    預覽
                  </button>
                  <button
                    type="button"
                    class="btn btn-success"
                    :disabled="clickDisabled"
                    @click="
                      clickDisabled = true;
                      updateLoading(true);
                      handleSubmit(sendInterviewInvitation);
                    "
                  >
                    寄出
                  </button>
                </div>
              </div>
            </form>
          </div>
        </ValidationObserver>
      </div>
    </div>

    <!-- 預覽 Modal -->
    <PreviewMailModal :type="'interview'" :mail="previewData" />
  </div>
</template>

<script>
/* global $ */
import { mapGetters, mapActions } from "vuex";
import PreviewMailModal from "@/components/back/Modal/PreviewMailModal.vue";

export default {
  props: ["personData"],

  name: "InterviewMailModal",
  components: {
    PreviewMailModal,
  },
  data() {
    return {
      // 範本
      mailParameters: {},
      mailTemplates: [],

      // 所選擇範本的 guid
      selectedTemplateGuid: null,

      // 為了辨別信件重複問題
      Guid: null,

      // 信件內容
      mail: {},
      // 預覽內容
      previewData: {},

      // 寄出按鈕
      clickDisabled: false,

      // 是否發送 mail
      sendMail: true,

      // 面談主管選項
      supervisorOptions: [],
      // 面談地點選項
      interviewPlaceOptions: [],

      // 附件
      fileGroupGuid: "",
      resetFileStatus: true, // 第一次必為 true
      uploadFileList: [], // 上傳附件列表
    };
  },

  computed: {
    ...mapGetters(["showInterviewMail"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  watch: {
    showInterviewMail: function (e) {
      if (e) {
        this.Guid = this.getGuid();
        this.selectedTemplateGuid = null;
        this.mail = {
          Email: this.personData.Email,
          Interviewee: this.personData.Name,
          Position: this.personData.Position,
          MatchId: this.personData.MatchId,
        };
        this.sendMail = true;
        this.fileGroupGuid = "";
        this.resetFileStatus = true;
        this.uploadFileList = [];
        this.$refs.letter.reset();
        this.clickDisabled = false;
        $("#interviewMailModal").modal("show");
      } else {
        $("#interviewMailModal").modal("hide");
      }
    },
  },

  methods: {
    // 上傳 附件
    uploadFile(file) {
      this.updateLoading(true);

      let fd = new FormData();
      fd.append("File", file.raw);
      fd.append("FileType", file.raw.type);
      fd.append("FileGroupGuid", this.fileGroupGuid);
      fd.append("CreateUser", null);

      this.$api.file.uploadFile(fd).then((response) => {
        if (response.status === 200) {
          this.updateLoading(false);
          this.fileGroupGuid = response.data;
          this.resetFileStatus = false;
          this.getFileList(this.fileGroupGuid);
        }
      });
    },

    // 取得 附件
    getFileList(fileGroupGuid) {
      this.updateLoading(true);
      const params = {
        resetFileStatus: this.resetFileStatus,
      };
      this.$api.file.getFileDetails(params, fileGroupGuid).then((response) => {
        if (response.status === 200) {
          this.uploadFileList = response.data.filter((item) => !item.IsDelete);
        }
        this.updateLoading(false);
      });
    },

    // 刪除 附件
    removeFile({ fileGuid, fileGroupGuid }) {
      this.updateLoading(true);
      this.$api.file.removeFile(fileGuid).then((response) => {
        if (response.status === 200) {
          this.$notify({
            title: "成功",
            message: "刪除成功",
            type: "success",
            duration: 2500,
          });
          this.uploadFileList = [];
          this.resetFileStatus = false;
          this.getFileList(fileGroupGuid);
        }
        this.updateLoading(false);
      });
    },

    // 面談邀約
    sendInterviewInvitation() {
      let api = this.sendMail
        ? "interviewInvitation"
        : "interviewInvitationNoMail";
      this.$api.sendmail[api]({
        ...this.mail,
        Guid: this.Guid,
        InterviewSupervisor: this.mail.InterviewSupervisor
          ? [this.mail.InterviewSupervisor]
          : null,
        InterviewHR: [this.mail.InterviewHR],
        CreateUser: this.$cookies.get("userName"),
        FileGroupId: this.fileGroupGuid ? this.fileGroupGuid : null,
      })
        .then((response) => {
          if (response.status === 200) {
            this.clickDisabled = false;
            this.updateLoading(false);
            this.$store.commit("OpenInterviewMailModal", false);
            this.$notify({
              title: "面談邀約成功",
              message: "已寄出信件",
              type: "success",
              duration: 2500,
            });
            this.$emit("updatePerson");
          }
        })
        .catch(() => {
          this.clickDisabled = false;
          this.updateLoading(false);
        });
    },

    // 依guid 取得信件範本內容
    getMailTemplateDetail() {
      this.updateLoading(true);
      this.$api.mailTemplate
        .getMailTemplateDetail(this.selectedTemplateGuid)
        .then((response) => {
          if (response.status === 200) {
            this.$set(
              this.mail,
              "MailSubject",
              response.data.MailTemplateSubject
            );
            this.$set(
              this.mail,
              "MailTemplateBody",
              response.data.MailTemplateBody
            );
          }
          this.updateLoading(false);
        });
    },

    // 預覽
    preview() {
      this.previewData = {
        ...this.mail,
        InterviewSupervisor: this.mail.InterviewSupervisor
          ? [this.mail.InterviewSupervisor]
          : null,
        InterviewHR: [this.mail.InterviewHR],
      };
      this.$store.commit("OpenPreviewMailModal", true);
    },

    // 點擊取消
    closeInterviewModal() {
      this.$store.commit("OpenInterviewMailModal", false);
    },

    async getData() {
      await this.$http
        .all([
          this.$api.backgroundUser.getBackgroundUser(),
          this.$api.mailTemplate.getMailParameter(
            "E6BA3540-BA9B-487A-BF90-F6D115C763AD"
          ),
          this.$api.mailTemplate.getMailTemplatePaging(
            { isPaging: false },
            "InterviewInvitation"
          ),
          this.$api.interviewPlace.getInterviewPlacePaging({ isPaging: false }),
        ])
        .then(
          this.$http.spread((backgroundUser, parameter, template, place) => {
            // 取得 主管選項
            this.supervisorOptions = backgroundUser.data.map((user) => {
              return {
                Guid: user.UserId,
                Name: user.Name,
                Email: user.Email,
              };
            });
            // 取得 信件參數
            this.mailParameters = parameter.data;
            // 取得 信件範本
            this.mailTemplates = template.data.Datas;
            // 取得 面談地點
            this.interviewPlaceOptions = place.data.Data;
          })
        );
    },

    // 隨機取得 guid
    getGuid() {
      return crypto.randomUUID();
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  created() {
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
    this.$store.commit("OpenInterviewMailModal", false);
  },
};
</script>

<style lang="scss" scoped>
#interviewMailModal {
  .modal-dialog {
    max-width: 960px;
    .modal-content {
      background-color: transparent;
      border: none;
    }
  }
}
</style>
